import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState } from
'react';


















const defaults = {
  state: {
    isMobile: false,
    device: {
      width: 0,
      height: 0
    },
    document: {
      width: 0,
      height: 0
    },
    orientation: 'portrait'
  }
};

// $FlowFixMe
const ViewportContext = createContext(defaults);

export function useViewportContext() {
  return useContext(ViewportContext);
}





const SizedViewPortProvider = ({ children }) => {
  const [dimensions, setDimensions] = useState({
    device: {
      width: window.outerWidth || 0,
      height: window.outerHeight || 0
    },
    document: {
      width: window.innerWidth || 0,
      height: window.innerHeight || 0
    }
  });
  const handleResize = () => {
    setDimensions({
      device: {
        width: window.outerWidth || 0,
        height: window.outerHeight || 0
      },
      document: {
        width: window.innerWidth || 0,
        height: window.innerHeight || 0
      }
    });
  };

  useEffect(() => handleResize(), []);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const isMobile = useMemo(() => {
    const {
      device: {
        width: deviceWidth,
        height: deviceHeight
      }
    } = dimensions;

    // isMobile will be true for mobile devices, regardless of whether they are in landscape or portrait view.
    return deviceWidth && deviceHeight && (
    deviceWidth <= 932 && deviceHeight <= 480 // landscape
    || deviceWidth <= 480 && deviceHeight <= 932); // portrait
  }, [dimensions]);

  const orientation = useMemo(() => {
    const {
      device: {
        width: deviceWidth,
        height: deviceHeight
      }
    } = dimensions;

    return deviceWidth > deviceHeight ? 'landscape' : 'portrait';
  }, [dimensions]);

  const state = {
    ...dimensions,
    isMobile: isMobile || false,
    orientation
  };

  return <ViewportContext.Provider value={{ state }}>{children}</ViewportContext.Provider>;
};

export const ViewportProvider = SizedViewPortProvider;